import { Box, Container } from '@mui/material'

export default function Content({ bgColor, children, appBar }) {
  return (
    <Box
      width='100%'
      sx={theme =>
        bgColor === 'gradient'
          ? {
              backgroundRepeat: 'no-repeat',
              backgroundImage:
                'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 90%), transparent)',
              ...theme.applyStyles('dark', {
                backgroundImage:
                  'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 16%), transparent)',
              }),
            }
          : { bgcolor: bgColor || 'white' }
      }>
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          pt: { xs: appBar ? 14 : 8, sm: appBar ? 20 : 8 },
          pb: { xs: 8, sm: 12 },
        }}>
        {children}
      </Container>
    </Box>
  )
}
